import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const TextAndImageRowsBase = styled.section`
  display: grid;
  gap: 2rem;
  overflow: hidden;
  margin: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${theme.colors.darkBlues[100]};
  color: ${theme.colors.white};

  ${theme.largerThan.lg} {
    gap: 5rem;
    padding: 3rem 1rem;
  }
`;

export const Feature = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${theme.largerThan.md} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 2rem;
  }

  ${theme.largerThan.xl} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5rem;
  }
`;

export const FeatureText = styled.div`
  ${theme.largerThan.md} {
    grid-column: span 4 / span 4;
  }

  ${theme.largerThan.xl} {
    grid-column: span 1 / span 1;
  }

  h3 {
    color: ${theme.colors.white};
  }
  h3:after {
    content: "";
    display: block;
    background-color: ${theme.colors.greens[100]};
    width: 4rem;
    height: 2px;
    margin: 1.3rem 0 1rem;
  }
  p.paragraph {
    margin: 1.5rem 0;
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: ${theme.fontWeights.light};
  }
  ul {
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: ${theme.fontWeights.light};
  }
`;

export const FeatureImage = styled.div`
  ${theme.largerThan.md} {
    grid-column: span 2 / span 2;
  }

  ${theme.largerThan.xl} {
    grid-column: span 1 / span 1;
  }

  .gatsby-image-wrapper.object-contain {
    width: 100%;
    height: 100%;
  }

  .gatsby-image-wrapper.object-contain img {
    object-fit: contain !important;
  }
`;
